import api from '@a/config';

const path = 'v1/prozesskontrollkarte/intervallart';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: () => api.get(path),
};
